import React from 'react';

import 'src/app/components/Loader.scss';


const Loader = () => (
  <div styleName="wrapper">
    <div styleName='wrapper__loader loader'>
      <svg styleName='loader__svg svg' viewBox="25 25 50 50">
        <circle styleName="svg__circle" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"/>
      </svg>
    </div>
  </div>
);

export default Loader;
